import { useEffect, useState } from "react";
import VerticalPage, { OpportunityList } from "@/components/VerticalPage";
import { MEDIA } from "@/lib/content";
import api from "@/lib/api";

export default function CRE() {
  const [opps, setOpps] = useState([]);
  useEffect(() => {
    api.get("/opportunities").then(({ data }) => setOpps(data.filter((o) => o.type?.toLowerCase().includes("cre") || o.type?.toLowerCase().includes("listing") || o.type?.toLowerCase().includes("deal")))).catch(() => {});
  }, []);

  return (
    <VerticalPage
      overline="Moaglee CRE"
      title="A Private Commercial Real Estate Network."
      subtitle="Moaglee CRE is a private commercial real estate network for owners, sellers, tenants, investors, and off-market opportunities."
      image={MEDIA.building}
      statement="Moaglee CRE is a private commercial real estate network for owners, sellers, tenants, investors, and off-market opportunities."
      bullets={[
        "Commercial listings & private seller network",
        "Buyer / investor requirements",
        "Tenant representation",
        "Off-market opportunities",
        "Landlord advisory",
      ]}
      redirectKey="cre"
      redirectLabel="Visit MoagleeCRE.com"
      forms={["property_owner", "tenant_requirement"]}
      sourcePage="/cre"
    >
      <div className="mt-14">
        <OpportunityList opportunities={opps} />
      </div>
    </VerticalPage>
  );
}
